export const homepageConfigs = { SOCIAL_HIGHLIGHTS: { MOST_BOOKED_CITY_ID: 83 } };
